import { useMutation, useQueryClient } from '@tanstack/react-query'
import { createDeadlineRequest } from '../../deadline-requests/api/deadlineRequestsApi'
import type { DeadlineRequestCreateInput } from '../../deadline-requests/types'

/**
 * Aksiyon detayından **termin güncelleme talebi** oluşturur (087/US1).
 *
 * <p>Talep aksiyonun hiçbir alanını değiştirmez; ancak detay yanıtındaki `deadlineRequestAllowed` ve
 * `pendingDeadlineRequestId` alanları değişir (buton yerini "onay bekliyor" bilgisine bırakır) → detay
 * sorgusu geçersizleştirilir. Talep listesi de bayatlar.
 *
 * <p>Uç ve tipler `features/deadline-requests` altında **tek kaynakta** durur; burada yalnız aksiyon
 * ekranının ihtiyaç duyduğu tazeleme davranışı eklenir (kopya api katmanı üretilmez — Reuse Mandate).
 */
export function useCreateDeadlineRequest(actionId: number | null) {
  const qc = useQueryClient()

  return useMutation({
    mutationFn: (body: DeadlineRequestCreateInput) => createDeadlineRequest(body),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['action-detail', actionId] })
      qc.invalidateQueries({ queryKey: ['deadline-update-requests'] })
    },
  })
}
